import u from "./ghl-ui.es1163.js";
import { createTheme as S } from "./ghl-ui.es855.js";
import I from "./ghl-ui.es1157.js";
import L from "./ghl-ui.es1164.js";
const T = (e) => {
  const {
    textColor2: o,
    successColor: t,
    infoColor: i,
    warningColor: n,
    errorColor: c,
    popoverColor: l,
    closeIconColor: s,
    closeIconColorHover: C,
    closeIconColorPressed: a,
    closeColorHover: m,
    closeColorPressed: f,
    textColor1: d,
    textColor3: g,
    borderRadius: r,
    fontWeightStrong: h,
    boxShadow2: x,
    lineHeight: p,
    fontSize: b
  } = e;
  return Object.assign(Object.assign({}, u), {
    borderRadius: r,
    lineHeight: p,
    fontSize: b,
    headerFontWeight: h,
    iconColor: o,
    iconColorSuccess: t,
    iconColorInfo: i,
    iconColorWarning: n,
    iconColorError: c,
    color: l,
    textColor: o,
    closeIconColor: s,
    closeIconColorHover: C,
    closeIconColorPressed: a,
    closeBorderRadius: r,
    closeColorHover: m,
    closeColorPressed: f,
    headerTextColor: d,
    descriptionTextColor: g,
    actionTextColor: o,
    boxShadow: x
  });
}, v = S({
  name: "Notification",
  common: I,
  peers: {
    Scrollbar: L
  },
  self: T
}), O = v;
export {
  O as default,
  T as self
};
